<app-modal>
    <div modal-header>
        <span i18n="Modal Titel for Login@@login.modal.title">Login</span>
    </div>
    <div modal-body>
        <form [formGroup]="form"  (ngSubmit)="onSubmit()">
          <div class="form-group text-center">
              <label i18n="Ask if no account yet@@login.modal.label.noAccount">No account yet?</label>
              <a [routerLink]="['', {outlets: { modal: ['register']}}]" skipLocationChange i18n="Opens Register Modal@@login.modal.link.register">Register one for free!</a>
          </div>
          <div class="form-group form-label-group">
              <input type="text" id="loginInputEmail" class="form-control" formControlName="email" required />
              <label for="loginInputEmail" i18n="Input Label@@login.form.email.label">Email address</label>
              <div *ngIf="form.controls.email.invalid && (form.controls.email.dirty || form.controls.email.touched)" class="invalid-tooltip">
                  <div *ngIf="form.controls.email.errors.required" i18n="Error message when no email is provided@@login.form.errors.email.required">Email is required.</div>
                  <div *ngIf="form.controls.email.errors.email" i18n="Error message when email is no valid address@@login.form.errors.email.invalid">Email needs to be a valid address.</div>
                  <div *ngIf="form.controls.email.errors.notFound" i18n="Error message user was not found@@login.form.errors.email.notFound">Email not found!</div>
              </div>
          </div>
          <div class="form-group form-label-group">
              <input type="password" id="loginInputPassword" class="form-control" formControlName="password" />
              <label for="loginInputPassword" i18n="Input Label@@login.form.password.label">Password</label>
              <div *ngIf="(form.controls.password.invalid && (form.controls.password.dirty || form.controls.password.touched))" class="invalid-tooltip">
                  <div *ngIf="form.controls.password.errors.required" i18n="Error message when no password is provided@@login.form.errors.password.required">Password is required.</div>
                  <div *ngIf="form.controls.password.errors.minlength" i18n="Error message when password hasn't reach min-lenght@@login.form.errors.password.minLength">Password needs to be at least 4 characters long!</div>
                  <div *ngIf="form.controls.password.errors.passwordWrong" i18n="Error message when password was wrong@@login.form.errors.password.wrong">Password wrong!</div>
              </div>
          </div>
          <div class="text-center">
            <div class="btn-primary-container">
              <button type="submit" class="btn btn-primary">
                  <span i18n="Login Form Submit button@@login.form.submit.label">Login</span>
              </button>
            </div>
          </div>
        </form>
        <div class="">
            <a [routerLink]="['', {outlets: { modal: ['lostPassword']}}]" skipLocationChange i18n="Opens Lost Password Modal@@login.modal.link.lostPassword">Password forgotten?</a>
        </div>
    </div>
</app-modal>